export const swapItems = [
  {
    id: 1,
    title: 'Vintage Wooden Bookshelf',
    category: 'Furniture',
    condition: 'Good',
    owner: 'Emma R.',
    location: 'Portland, OR',
    distance: '2.3 miles',
    image: 'https://public.readdy.ai/ai/img_res/1336e7a34e383203614f3997d6feb042.jpg',
    description: 'Beautiful vintage bookshelf in great condition. Perfect for home library or office.',
    postedDate: '2 days ago',
    interested: 12
  },
  {
    id: 2,
    title: 'DSLR Camera Canon EOS',
    category: 'Electronics',
    condition: 'Excellent',
    owner: 'Marcus T.',
    location: 'Austin, TX',
    distance: '5.1 miles',
    image: 'https://readdy.ai/api/search-image?query=Professional%20DSLR%20camera%20Canon%20with%20lens%20on%20clean%20surface%2C%20modern%20photography%20equipment%2C%20high%20quality%20camera%20gear%20in%20excellent%20condition%2C%20minimal%20background%2C%20well-maintained%20technology&width=400&height=400&seq=swap-item-002&orientation=squarish',
    description: 'Canon DSLR with 18-55mm lens. Barely used, comes with camera bag and accessories.',
    postedDate: '1 day ago',
    interested: 24
  },
  {
    id: 3,
    title: 'Acoustic Guitar Yamaha',
    category: 'Musical Instruments',
    condition: 'Good',
    owner: 'Sarah K.',
    location: 'Seattle, WA',
    distance: '3.7 miles',
    image: 'https://readdy.ai/api/search-image?query=Acoustic%20guitar%20Yamaha%20with%20natural%20wood%20finish%2C%20beautiful%20musical%20instrument%20in%20good%20condition%2C%20warm%20lighting%20highlighting%20wood%20grain%2C%20simple%20clean%20background&width=400&height=400&seq=swap-item-003&orientation=squarish',
    description: 'Yamaha acoustic guitar, great sound quality. Perfect for beginners or intermediate players.',
    postedDate: '3 days ago',
    interested: 18
  },
  {
    id: 4,
    title: 'Ergonomic Office Chair',
    category: 'Furniture',
    condition: 'Excellent',
    owner: 'David L.',
    location: 'Denver, CO',
    distance: '1.8 miles',
    image: 'https://readdy.ai/api/search-image?query=Modern%20ergonomic%20office%20chair%20in%20black%20color%2C%20comfortable%20desk%20chair%20with%20adjustable%20features%2C%20professional%20office%20furniture%2C%20clean%20minimal%20background&width=400&height=400&seq=swap-item-004&orientation=squarish',
    description: 'High-quality ergonomic chair with lumbar support. Barely used, like new condition.',
    postedDate: '1 day ago',
    interested: 31
  },
  {
    id: 5,
    title: 'Mountain Bike Trek',
    category: 'Sports',
    condition: 'Good',
    owner: 'Chris M.',
    location: 'Portland, OR',
    distance: '4.2 miles',
    image: 'https://readdy.ai/api/search-image?query=Mountain%20bike%20Trek%20in%20good%20condition%2C%20outdoor%20sports%20bicycle%20with%20sturdy%20frame%2C%20adventure%20cycling%20equipment%2C%20simple%20background%20highlighting%20the%20bike&width=400&height=400&seq=swap-item-005&orientation=squarish',
    description: 'Trek mountain bike, 21-speed. Great for trails and city riding.',
    postedDate: '4 days ago',
    interested: 15
  },
  {
    id: 6,
    title: 'Espresso Coffee Machine',
    category: 'Kitchen',
    condition: 'Excellent',
    owner: 'Rachel P.',
    location: 'Austin, TX',
    distance: '6.3 miles',
    image: 'https://readdy.ai/api/search-image?query=Modern%20espresso%20coffee%20machine%20in%20stainless%20steel%2C%20professional%20home%20coffee%20maker%2C%20kitchen%20appliance%20in%20excellent%20condition%2C%20clean%20minimal%20background&width=400&height=400&seq=swap-item-006&orientation=squarish',
    description: 'Professional-grade espresso machine. Makes perfect coffee every time.',
    postedDate: '2 days ago',
    interested: 27
  },
  {
    id: 7,
    title: 'Yoga Mat Set with Blocks',
    category: 'Sports',
    condition: 'Good',
    owner: 'Nina A.',
    location: 'San Francisco, CA',
    distance: '3.1 miles',
    image: 'https://readdy.ai/api/search-image?query=Yoga%20mat%20set%20with%20blocks%20and%20strap%20in%20teal%20color%2C%20fitness%20wellness%20equipment%2C%20exercise%20accessories%20in%20good%20condition%2C%20peaceful%20minimal%20background&width=400&height=400&seq=swap-item-007&orientation=squarish',
    description: 'Complete yoga set including mat, blocks, and strap. Lightly used.',
    postedDate: '5 days ago',
    interested: 9
  },
  {
    id: 8,
    title: 'Electric Keyboard Piano',
    category: 'Musical Instruments',
    condition: 'Excellent',
    owner: 'Jordan T.',
    location: 'Boston, MA',
    distance: '2.9 miles',
    image: 'https://readdy.ai/api/search-image?query=Electric%20keyboard%20piano%20with%20stand%2C%20modern%20digital%20piano%20instrument%2C%2088%20keys%20music%20equipment%20in%20excellent%20condition%2C%20clean%20background&width=400&height=400&seq=swap-item-008&orientation=squarish',
    description: '88-key electric piano with stand and pedal. Perfect sound quality.',
    postedDate: '1 day ago',
    interested: 22
  },
  {
    id: 9,
    title: 'Camping Tent 4-Person',
    category: 'Sports',
    condition: 'Good',
    owner: 'Mike R.',
    location: 'Denver, CO',
    distance: '5.7 miles',
    image: 'https://readdy.ai/api/search-image?query=Four%20person%20camping%20tent%20in%20green%20color%2C%20outdoor%20adventure%20equipment%2C%20family%20camping%20gear%20in%20good%20condition%2C%20simple%20background%20highlighting%20the%20tent&width=400&height=400&seq=swap-item-009&orientation=squarish',
    description: 'Spacious 4-person tent, waterproof and easy to set up. Used only twice.',
    postedDate: '3 days ago',
    interested: 14
  },
  {
    id: 10,
    title: 'Vintage Vinyl Record Player',
    category: 'Electronics',
    condition: 'Good',
    owner: 'Lisa H.',
    location: 'Seattle, WA',
    distance: '4.5 miles',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20vinyl%20record%20player%20turntable%20in%20wood%20finish%2C%20retro%20music%20equipment%2C%20classic%20audio%20device%20in%20good%20condition%2C%20warm%20lighting%20simple%20background&width=400&height=400&seq=swap-item-010&orientation=squarish',
    description: 'Classic turntable with built-in speakers. Works perfectly, great sound.',
    postedDate: '6 days ago',
    interested: 19
  },
  {
    id: 11,
    title: 'Standing Desk Adjustable',
    category: 'Furniture',
    condition: 'Excellent',
    owner: 'Tom B.',
    location: 'Portland, OR',
    distance: '1.5 miles',
    image: 'https://readdy.ai/api/search-image?query=Modern%20adjustable%20standing%20desk%20in%20white%20color%2C%20ergonomic%20office%20furniture%2C%20height%20adjustable%20workspace%20in%20excellent%20condition%2C%20clean%20minimal%20background&width=400&height=400&seq=swap-item-011&orientation=squarish',
    description: 'Electric standing desk with memory presets. Like new condition.',
    postedDate: '2 days ago',
    interested: 28
  },
  {
    id: 12,
    title: 'Road Bike Specialized',
    category: 'Sports',
    condition: 'Excellent',
    owner: 'Alex K.',
    location: 'San Francisco, CA',
    distance: '2.2 miles',
    image: 'https://readdy.ai/api/search-image?query=Road%20bike%20Specialized%20in%20red%20color%2C%20professional%20cycling%20equipment%2C%20lightweight%20racing%20bicycle%20in%20excellent%20condition%2C%20simple%20background%20highlighting%20the%20bike&width=400&height=400&seq=swap-item-012&orientation=squarish',
    description: 'Specialized road bike, carbon frame. Perfect for long distance rides.',
    postedDate: '1 day ago',
    interested: 33
  },
  {
    id: 13,
    title: 'Honda Civic 2018',
    category: 'Vehicles',
    condition: 'Excellent',
    owner: 'James W.',
    location: 'Portland, OR',
    distance: '3.4 miles',
    image: 'https://readdy.ai/api/search-image?query=Honda%20Civic%202018%20sedan%20in%20silver%20color%20parked%20in%20clean%20environment%2C%20modern%20compact%20car%20in%20excellent%20condition%2C%20well-maintained%20vehicle%20exterior%2C%20simple%20neutral%20background%20highlighting%20the%20automobile&width=400&height=400&seq=swap-item-013&orientation=squarish',
    description: '2018 Honda Civic, 45k miles. Single owner, excellent fuel economy, all maintenance records available.',
    postedDate: '1 day ago',
    interested: 42
  },
  {
    id: 14,
    title: 'Harley Davidson Motorcycle',
    category: 'Vehicles',
    condition: 'Good',
    owner: 'Rick D.',
    location: 'Austin, TX',
    distance: '7.2 miles',
    image: 'https://readdy.ai/api/search-image?query=Harley%20Davidson%20motorcycle%20in%20black%20color%20with%20chrome%20details%2C%20classic%20American%20cruiser%20bike%20in%20good%20condition%2C%20powerful%20motorcycle%20with%20leather%20seat%2C%20clean%20simple%20background%20highlighting%20the%20bike&width=400&height=400&seq=swap-item-014&orientation=squarish',
    description: 'Classic Harley Davidson cruiser. 15k miles, custom exhaust, well maintained.',
    postedDate: '3 days ago',
    interested: 38
  },
  {
    id: 15,
    title: 'Toyota Camry 2020',
    category: 'Vehicles',
    condition: 'Excellent',
    owner: 'Michelle S.',
    location: 'Seattle, WA',
    distance: '2.8 miles',
    image: 'https://readdy.ai/api/search-image?query=Toyota%20Camry%202020%20sedan%20in%20white%20color%2C%20reliable%20family%20car%20in%20excellent%20condition%2C%20modern%20sedan%20with%20sleek%20design%2C%20clean%20neutral%20background%20highlighting%20the%20vehicle&width=400&height=400&seq=swap-item-015&orientation=squarish',
    description: '2020 Toyota Camry, 28k miles. Like new, warranty still active, backup camera and safety features.',
    postedDate: '2 days ago',
    interested: 51
  },
  {
    id: 16,
    title: 'Yamaha R6 Sport Bike',
    category: 'Vehicles',
    condition: 'Good',
    owner: 'Tyler M.',
    location: 'Denver, CO',
    distance: '4.9 miles',
    image: 'https://readdy.ai/api/search-image?query=Yamaha%20R6%20sport%20motorcycle%20in%20racing%20colors%2C%20high%20performance%20sportbike%20in%20good%20condition%2C%20sleek%20aerodynamic%20design%2C%20simple%20background%20highlighting%20the%20motorcycle&width=400&height=400&seq=swap-item-016&orientation=squarish',
    description: 'Yamaha R6 600cc sport bike. 12k miles, new tires, perfect for track or street.',
    postedDate: '4 days ago',
    interested: 29
  },
  {
    id: 17,
    title: 'Ford F-150 Pickup Truck',
    category: 'Vehicles',
    condition: 'Good',
    owner: 'Brandon K.',
    location: 'Austin, TX',
    distance: '5.6 miles',
    image: 'https://readdy.ai/api/search-image?query=Ford%20F-150%20pickup%20truck%20in%20dark%20color%2C%20powerful%20American%20truck%20in%20good%20condition%2C%20rugged%20utility%20vehicle%20with%20large%20bed%2C%20clean%20background%20highlighting%20the%20truck&width=400&height=400&seq=swap-item-017&orientation=squarish',
    description: '2017 Ford F-150, 4x4, crew cab. 65k miles, towing package, bed liner included.',
    postedDate: '5 days ago',
    interested: 35
  },
  {
    id: 18,
    title: 'Vespa Scooter 150cc',
    category: 'Vehicles',
    condition: 'Excellent',
    owner: 'Sofia L.',
    location: 'San Francisco, CA',
    distance: '1.9 miles',
    image: 'https://readdy.ai/api/search-image?query=Vespa%20scooter%20in%20mint%20green%20color%2C%20classic%20Italian%20scooter%20in%20excellent%20condition%2C%20stylish%20urban%20transportation%2C%20simple%20clean%20background%20highlighting%20the%20scooter&width=400&height=400&seq=swap-item-018&orientation=squarish',
    description: 'Classic Vespa 150cc scooter. Perfect for city commuting, low mileage, very fuel efficient.',
    postedDate: '1 day ago',
    interested: 26
  },
  {
    id: 19,
    title: 'Jeep Wrangler 2019',
    category: 'Vehicles',
    condition: 'Excellent',
    owner: 'Derek P.',
    location: 'Denver, CO',
    distance: '3.3 miles',
    image: 'https://readdy.ai/api/search-image?query=Jeep%20Wrangler%202019%20in%20forest%20green%20color%2C%20rugged%20off-road%20SUV%20in%20excellent%20condition%2C%20adventure%20vehicle%20with%20removable%20top%2C%20clean%20background%20highlighting%20the%20Jeep&width=400&height=400&seq=swap-item-019&orientation=squarish',
    description: '2019 Jeep Wrangler Unlimited. 35k miles, lift kit, off-road tires, removable hardtop.',
    postedDate: '2 days ago',
    interested: 47
  },
  {
    id: 20,
    title: 'BMW 3 Series 2017',
    category: 'Vehicles',
    condition: 'Good',
    owner: 'Andrew C.',
    location: 'Boston, MA',
    distance: '6.1 miles',
    image: 'https://readdy.ai/api/search-image?query=BMW%203%20Series%20sedan%20in%20metallic%20gray%20color%2C%20luxury%20sports%20sedan%20in%20good%20condition%2C%20elegant%20German%20automobile%20with%20premium%20features%2C%20clean%20background%20highlighting%20the%20car&width=400&height=400&seq=swap-item-020&orientation=squarish',
    description: '2017 BMW 328i, 52k miles. Leather interior, navigation, premium sound system.',
    postedDate: '3 days ago',
    interested: 44
  },
  {
    id: 21,
    title: 'Kawasaki Ninja 650',
    category: 'Vehicles',
    condition: 'Excellent',
    owner: 'Kevin H.',
    location: 'Portland, OR',
    distance: '4.7 miles',
    image: 'https://readdy.ai/api/search-image?query=Kawasaki%20Ninja%20650%20motorcycle%20in%20green%20and%20black%20colors%2C%20mid-size%20sport%20bike%20in%20excellent%20condition%2C%20sleek%20Japanese%20motorcycle%2C%20simple%20background%20highlighting%20the%20bike&width=400&height=400&seq=swap-item-021&orientation=squarish',
    description: 'Kawasaki Ninja 650, 8k miles. Perfect beginner to intermediate bike, very reliable.',
    postedDate: '2 days ago',
    interested: 31
  },
  {
    id: 22,
    title: 'Tesla Model 3 2021',
    category: 'Vehicles',
    condition: 'Excellent',
    owner: 'Nathan R.',
    location: 'San Francisco, CA',
    distance: '2.4 miles',
    image: 'https://readdy.ai/api/search-image?query=Tesla%20Model%203%20electric%20car%20in%20pearl%20white%20color%2C%20modern%20electric%20vehicle%20in%20excellent%20condition%2C%20futuristic%20sedan%20with%20autopilot%2C%20clean%20background%20highlighting%20the%20Tesla&width=400&height=400&seq=swap-item-022&orientation=squarish',
    description: '2021 Tesla Model 3 Long Range. 22k miles, autopilot, premium interior, supercharging included.',
    postedDate: '1 day ago',
    interested: 68
  }
];

export const categories = [
  'All Categories',
  'Furniture',
  'Electronics',
  'Musical Instruments',
  'Sports',
  'Kitchen',
  'Books',
  'Toys',
  'Tools',
  'Garden',
  'Vehicles'
];

export const conditions = [
  'All Conditions',
  'Excellent',
  'Good',
  'Fair'
];

export const locations = [
  'All Locations',
  'Portland, OR',
  'Austin, TX',
  'Seattle, WA',
  'Denver, CO',
  'San Francisco, CA',
  'Boston, MA'
];
